const supplierSettings = {
  status: true,
  items: true,
  error_code: true,
  error: true,
};

export { supplierSettings };